import { OTPVerificationScreen } from "@/features/auth";
export default OTPVerificationScreen;
